var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReferralAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9805 2.01953C8.79895 2.01953 6.21055 4.60797 6.21055 7.78949C6.21055 9.76016 7.20387 11.503 8.7159 12.5443C7.30422 13.0315 6.01031 13.8362 4.92328 14.9232C3.03816 16.8084 2 19.3146 2 21.9805H3.55945C3.55945 17.3371 7.33711 13.5595 11.9805 13.5595C15.1621 13.5595 17.7505 10.9711 17.7505 7.78949C17.7505 4.60793 15.1621 2.01953 11.9805 2.01953ZM11.9805 12C9.65883 12 7.77 10.1112 7.77 7.78953C7.77 5.46785 9.65883 3.57898 11.9805 3.57898C14.3022 3.57898 16.191 5.46781 16.191 7.78953C16.191 10.1112 14.3022 12 11.9805 12Z",
    fill: "#525975"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.725 17.146V13.8711H17.1655V17.146H13.8906V18.7054H17.1655V21.9803H18.725V18.7054H21.9998V17.146H18.725Z",
    fill: "#525975"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralAdd);
export default __webpack_public_path__ + "static/media/referralAdd.8d692a96.svg";
export { ForwardRef as ReactComponent };